export default {"src":"/_next/static/media/google-calendar.ae172e2b.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};